import { useSettings } from './context/SettingsContext';
import hindi from './locales/hi';

export const translations = {
  en: {
    dashboard: 'Dashboard',
    products: 'Products',
    newBill: 'New Bill',
    sales: 'Sales',
    stock: 'Stock',
    customers: 'Customers',
    suppliers: 'Suppliers',
    reports: 'Reports',
    backup: 'Backup & Restore',
    settings: 'Settings',
    totalProducts: 'Total Products',
    stockCostValue: 'Stock Cost Value',
    stockSellingValue: 'Stock Selling Value',
    lowStock: 'Low Stock',
    outOfStock: 'Out of Stock',
    todaysSales: "Today's Sales",
    todaysInvoices: "Today's Invoices",
    monthSales: 'This Month Sales',
    recentInvoices: 'Recent Invoices',
    pendingPayments: 'Pending Payments / Udhaar',
    addProduct: 'Add Product',
    save: 'Save',
    cancel: 'Cancel',
    print: 'Print',
    search: 'Search',
    download: 'Download',
    inStock: 'In Stock',
  },
  hi: {
    dashboard: 'डैशबोर्ड',
    products: 'सामान',
    newBill: 'नया बिल',
    sales: 'बिक्री',
    stock: 'स्टॉक',
    customers: 'ग्राहक',
    suppliers: 'सप्लायर',
    reports: 'रिपोर्ट',
    backup: 'बैकअप और रीस्टोर',
    settings: 'सेटिंग्स',
    totalProducts: 'कुल सामान',
    stockCostValue: 'स्टॉक लागत मूल्य',
    stockSellingValue: 'स्टॉक बिक्री मूल्य',
    lowStock: 'कम स्टॉक',
    outOfStock: 'स्टॉक खत्म',
    todaysSales: 'आज की बिक्री',
    todaysInvoices: 'आज के बिल',
    monthSales: 'इस माह की बिक्री',
    recentInvoices: 'हाल के बिल',
    pendingPayments: 'बकाया / उधार',
    addProduct: 'सामान जोड़ें',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    print: 'प्रिंट',
    search: 'खोजें',
    download: 'डाउनलोड',
    inStock: 'स्टॉक में',
  },
};

export function t(lang, key) {
  return (lang === 'hi' ? hindi[key] : null) || translations[lang]?.[key] || translations.en[key] || key;
}

export function useT() {
  const { settings } = useSettings();
  return key => t(settings.language, key);
}
